'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { init, loadRemote } from '@module-federation/runtime/dist/index.cjs.js';

let metaMaskSnapWallet;
/**
 *
 * @param {IEthereum} provider the metamask window provider object
 * @returns {StarknetWindowObject} the metamask provider wrapper formed into starknet window object
 */
const createMetaMaskProviderWrapper = (provider) => {
    const metaMaskProviderWrapper = {
        get account() {
            return metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.account;
        },
        get chainId() {
            return metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.chainId;
        },
        enable: () => __awaiter(void 0, void 0, void 0, function* () {
            if (!metaMaskSnapWallet) {
                yield init({
                    name: 'MetaMaskStarknetSnapWallet',
                    remotes: [
                        {
                            alias: 'MetaMaskStarknetSnapWallet',
                            entry: 'https://snaps.consensys.io/starknet/get-starknet/v1/remoteEntry.js',
                            name: 'MetaMaskStarknetSnapWallet',
                        },
                    ],
                });
                const result = yield loadRemote('MetaMaskStarknetSnapWallet/index');
                const { MetaMaskSnapWallet } = result;
                metaMaskSnapWallet = new MetaMaskSnapWallet(provider, '*');
            }
            if (!metaMaskSnapWallet) {
                return [];
            }
            return metaMaskSnapWallet.enable();
        }),
        icon: '',
        id: 'MetaMaskStarknetSnapWallet',
        get isConnected() {
            return metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.isConnected;
        },
        isPreauthorized: () => { var _a; return (_a = metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.isPreauthorized()) !== null && _a !== void 0 ? _a : Promise.resolve(false); },
        name: 'MetaMaskStarknetSnapWallet',
        off: (
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        event, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handleEvent) => undefined,
        on: (
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        event, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handleEvent) => undefined,
        get provider() {
            return metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.provider;
        },
        request: (call) => {
            if (!metaMaskSnapWallet) {
                throw new Error('Wallet not enabled');
            }
            return metaMaskSnapWallet.request(call);
        },
        get selectedAddress() {
            return metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.selectedAddress;
        },
        get version() {
            var _a;
            return (_a = metaMaskSnapWallet === null || metaMaskSnapWallet === void 0 ? void 0 : metaMaskSnapWallet.version) !== null && _a !== void 0 ? _a : '0.0.0';
        },
    };
    return metaMaskProviderWrapper;
};

export { createMetaMaskProviderWrapper };
